// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ArrivalSection_container__bCEmD {
  border-radius: 10px;
  text-align: left;
  padding-bottom: 30px;

}

.ArrivalSection_blockMoney__tRXV\\+ {
  display: flex;
  gap: 25px;
}

.ArrivalSection_blockMoneyThree__oVDVn,
.ArrivalSection_blockMoneyTwo__Q5n-P,
.ArrivalSection_blockMoneyOne__c7so1 {
  width: 245px;
  background: white;
  padding: 1.25rem 1.25rem;
  border-radius: 10px;
}

.ArrivalSection_blockMoneyHead__23hwk {
  font-size: 1.1rem;
}

.ArrivalSection_blockMoneySum__kijfc {
  margin-top: 10px;
  font-size: 1.75rem;
}

.ArrivalSection_blockMoneyOne__c7so1 .ArrivalSection_blockMoneySum__kijfc {
  color: brown;
}

.ArrivalSection_blockMoneyTwo__Q5n-P .ArrivalSection_blockMoneySum__kijfc {
  color: blue;
}

.ArrivalSection_blockMoneyThree__oVDVn .ArrivalSection_blockMoneySum__kijfc {
  color: rgba(29, 135, 82, 1);
}

.ArrivalSection_filter__nefwz {
  display: grid;
  background: white;
  border-radius: 10px;
  padding: 20px 15px;
  grid-template-columns: repeat(6, 1fr); 
  gap: 20px;
  margin: 20px 0;
}

.ArrivalSection_date__gBy0x {
  padding: 5px;
  border-radius: 5px;
  background: white;
  border: 1px solid rgba(203, 213, 225, 1);
}
.ArrivalSection_tableWrapper__hBcrd {
  max-height: 24vw;
  overflow-y: auto; /* важен для «липкой» шапки внутри контейнера */
  overflow-x: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  position: relative; 
}

/* убери overflow:hidden у самой таблицы, иначе может клипать */
.ArrivalSection_table__UbZT7 {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  /* overflow: hidden;  <-- убираем */
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

/* фиксируем шапку внутри scroll-контейнера */
.ArrivalSection_table__UbZT7 thead th {
  position: sticky;
  top: 0; /* расстояние от верхней границы контейнера .tableWrapper */
  z-index: 5;
  background-color: #f9f9f9;
}

.ArrivalSection_page__yTPoh {
  color: red;
}
.ArrivalSection_table__UbZT7 th,
.ArrivalSection_table__UbZT7 td {
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  text-align: left;
  font-size: 14px;
}

.ArrivalSection_table__UbZT7 th {
  background-color: #f9f9f9;
  font-weight: 600;
  color: #333;
}

.ArrivalSection_table__UbZT7 tr:hover {
  background-color: #f5f5f5;
}

.ArrivalSection_addCustomers__ntnYL {
  position: absolute;
  top: 10.6rem;
  right: 2rem;
  background: rgba(29, 135, 82, 1);
  color: white;
  padding: 5px 20px;
  border-radius: 5px;
  font-size: 25px;
}

.ArrivalSection_radioLabel__PzwBa {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 16px;
}

.ArrivalSection_radioInput__T8WSQ {
  display: none;
}

.ArrivalSection_radioCustom__TQt5A {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(29, 135, 82, 1);
  border-radius: 50%;
  background-color: white;
  position: relative;
  transition: 0.2s ease;
}

.ArrivalSection_radioInput__T8WSQ:checked + .ArrivalSection_radioCustom__TQt5A::after {
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  width: 8px;
  height: 8px;
  background-color: rgba(29, 135, 82, 1);
  border-radius: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/tablesStyle/ArrivalSection.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;;AAEtB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;;EAGE,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;AAC1C;AACA;EACE,gBAAgB;EAChB,gBAAgB,EAAE,+CAA+C;EACjE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,+DAA+D;AAC/D;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA,6CAA6C;AAC7C;EACE,gBAAgB;EAChB,MAAM,EAAE,2DAA2D;EACnE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,sCAAsC;EACtC,kBAAkB;AACpB","sourcesContent":[".container {\n  border-radius: 10px;\n  text-align: left;\n  padding-bottom: 30px;\n\n}\n\n.blockMoney {\n  display: flex;\n  gap: 25px;\n}\n\n.blockMoneyThree,\n.blockMoneyTwo,\n.blockMoneyOne {\n  width: 245px;\n  background: white;\n  padding: 1.25rem 1.25rem;\n  border-radius: 10px;\n}\n\n.blockMoneyHead {\n  font-size: 1.1rem;\n}\n\n.blockMoneySum {\n  margin-top: 10px;\n  font-size: 1.75rem;\n}\n\n.blockMoneyOne .blockMoneySum {\n  color: brown;\n}\n\n.blockMoneyTwo .blockMoneySum {\n  color: blue;\n}\n\n.blockMoneyThree .blockMoneySum {\n  color: rgba(29, 135, 82, 1);\n}\n\n.filter {\n  display: grid;\n  background: white;\n  border-radius: 10px;\n  padding: 20px 15px;\n  grid-template-columns: repeat(6, 1fr); \n  gap: 20px;\n  margin: 20px 0;\n}\n\n.date {\n  padding: 5px;\n  border-radius: 5px;\n  background: white;\n  border: 1px solid rgba(203, 213, 225, 1);\n}\n.tableWrapper {\n  max-height: 24vw;\n  overflow-y: auto; /* важен для «липкой» шапки внутри контейнера */\n  overflow-x: auto;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  position: relative; \n}\n\n/* убери overflow:hidden у самой таблицы, иначе может клипать */\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 8px;\n  /* overflow: hidden;  <-- убираем */\n  box-shadow: 0 2px 6px rgba(0,0,0,0.05);\n}\n\n/* фиксируем шапку внутри scroll-контейнера */\n.table thead th {\n  position: sticky;\n  top: 0; /* расстояние от верхней границы контейнера .tableWrapper */\n  z-index: 5;\n  background-color: #f9f9f9;\n}\n\n.page {\n  color: red;\n}\n.table th,\n.table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #e0e0e0;\n  text-align: left;\n  font-size: 14px;\n}\n\n.table th {\n  background-color: #f9f9f9;\n  font-weight: 600;\n  color: #333;\n}\n\n.table tr:hover {\n  background-color: #f5f5f5;\n}\n\n.addCustomers {\n  position: absolute;\n  top: 10.6rem;\n  right: 2rem;\n  background: rgba(29, 135, 82, 1);\n  color: white;\n  padding: 5px 20px;\n  border-radius: 5px;\n  font-size: 25px;\n}\n\n.radioLabel {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.radioInput {\n  display: none;\n}\n\n.radioCustom {\n  width: 18px;\n  height: 18px;\n  border: 2px solid rgba(29, 135, 82, 1);\n  border-radius: 50%;\n  background-color: white;\n  position: relative;\n  transition: 0.2s ease;\n}\n\n.radioInput:checked + .radioCustom::after {\n  content: '';\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 8px;\n  height: 8px;\n  background-color: rgba(29, 135, 82, 1);\n  border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ArrivalSection_container__bCEmD`,
	"blockMoney": `ArrivalSection_blockMoney__tRXV+`,
	"blockMoneyThree": `ArrivalSection_blockMoneyThree__oVDVn`,
	"blockMoneyTwo": `ArrivalSection_blockMoneyTwo__Q5n-P`,
	"blockMoneyOne": `ArrivalSection_blockMoneyOne__c7so1`,
	"blockMoneyHead": `ArrivalSection_blockMoneyHead__23hwk`,
	"blockMoneySum": `ArrivalSection_blockMoneySum__kijfc`,
	"filter": `ArrivalSection_filter__nefwz`,
	"date": `ArrivalSection_date__gBy0x`,
	"tableWrapper": `ArrivalSection_tableWrapper__hBcrd`,
	"table": `ArrivalSection_table__UbZT7`,
	"page": `ArrivalSection_page__yTPoh`,
	"addCustomers": `ArrivalSection_addCustomers__ntnYL`,
	"radioLabel": `ArrivalSection_radioLabel__PzwBa`,
	"radioInput": `ArrivalSection_radioInput__T8WSQ`,
	"radioCustom": `ArrivalSection_radioCustom__TQt5A`
};
export default ___CSS_LOADER_EXPORT___;
